{
  "pt": {
    "chart": {
      "type": {
        "bar": "Gráfico de barras",
        "bubble": "Gráfico de bolhas",
        "doughnut": "Gráfico de rosca",
        "horizontalBar": "Gráfico de barras horizontais",
        "line": "Gráfico de linhas",
        "multiAxis": "Gráfico multi-eixos",
        "pie": "Gráfico de pizza",
        "polarArea": "Gráfico de área polar",
        "radar": "Gráfico radar",
        "stackedBar": "Gráfico de barras empilhadas"
      }
    }
  }
}